// extracted by mini-css-extract-plugin
export var card = "_v1-0";